define([
    "dojo/_base/declare",
    "./NewStyleCandidateController"
], function(declare, NewStyleCandidateController) {
    var SEASON = "ParentSeason"

    return declare([NewStyleCandidateController], {

        /**
         * @override
         */
		addStyleOrCandidateOperation: "AddStyleOrCandidatesAsSystem",

        /**
         * @override
         */
		pushMappingOperation: "PushMappingAttributesToStyleForCreateAsSystem",

        /**
         * @override
         */
        onCreatePopup: function(/*csi.view.Widget*/view) {
            const seasonURL = view.cacheView.getNode(this.getParent().Season).ApparelSeason
            view.addFixedValue(SEASON, seasonURL);
            this.inherited(arguments);
        }
    });
});